module.exports = __webpack_public_path__ + "img/barcelo-room-3.bd9a8d48.jpg";